<template>
  <div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="ehs-donut-loading"
      class="vs-con-loading__container px-2 widget-card"
      style="position: relative"
    >
    <card-header :title="$t('widget_ehs_by_status')"></card-header>
      <vs-row>
        <vs-col>
          <div class="body-card-widget">
            <vue-apex-charts
              class="mt-6 mb-8"
              type="donut"
              height="325"
              :options="chartOptions"
              :series="series"
            />
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import EhsDonutConfig from './EhsDonutConfig.js'
import VueApexCharts from 'vue-apexcharts'
//requests
import dashboard from '@/http/requests/ehs'

import loading from '@/mixins/Loading.js'
import CardHeader from './CardHeader.vue'
export default {
  mixins: [loading],
  components: {
    EhsDonutConfig,
    VueApexCharts,
    CardHeader
  },
  props: {
    tableHeight: {
      type: Number,
      default: 60,
    },
  },
  computed: {
    isLoading() {
      return this.loading.ehs_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('ehs-donut-loading')
      } else {
        this.closeLoading('ehs-donut-loading')
      }
    },
  },
  data() {
    return {
      series: [1],
      colors: [],
      labelsDonut: [],
      permitList: [],
      chartOptions: EhsDonutConfig,
      loading: {
        ehs_donut: false,
      },
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.loading.ehs_donut = true
      dashboard
        .ehsTableList()
        .then((res) => {
          this.permitList = res.data.permissions
          this.fillChartData(this.permitList)
          this.loading.ehs_donut = false
        })
        .catch((err) => {
          console.log(err)
          this.loading.ehs_donut = false
        })
    },
    countByState(data, state) {
      let count = 0
      data.forEach((element) => {
        if (element.status_name == state) {
          count++
        }
      })
      return count
    },
    fillChartData(dataToChart) {
      const dataValues = []
      const states = []
      dataToChart.forEach((element) => {
        if (states.indexOf(element.status_name) === -1) {
          states[states.length] = element.status_name
          this.colors[this.colors.length] =
            element.status_color == null ? '#E8ECE9' : element.status_color //Si no hay color en DB poner Gris Default
        }
      })
      states.forEach((element) => {
        dataValues[dataValues.length] = this.countByState(dataToChart, element)
      })
      this.series = dataValues
      this.labelsDonut = states
      ApexCharts.exec(
        'mychart',
        'updateOptions',
        {
          fill: {
            colors: this.colors,
          },
          legend: {
            markers: {
              fillColors: this.colors,
            },
          },
          labels: this.labelsDonut,
        },
        false,
        true
      )
    },
  },
}
</script>

<style>
.center-item {
  display: flex;
  align-items: center;
  text-align: center;
}
</style>

